import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../../services/language.service";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrl: './features.component.scss'
})
export class FeaturesComponent  implements OnInit, OnDestroy {
  private _translateService: TranslateService = inject(TranslateService);
  private _languageService: LanguageService = inject(LanguageService);

  @Input() giPantMode: boolean = false;
  @Input() henterPantMode: boolean = false;
  @Input() endConsumerMode: boolean = false;
  @Input() playerMode: boolean = false;
  @Input() teamMode: boolean = false;

  tabs!: ContentConfigTabItem[];
  activeTab!: ContentConfigTabItem;
  langSubscription!: Subscription;
  contentConfig!: {endConsumer: {tabs: ContentConfigTabItem[]}; player: {tabs: ContentConfigTabItem[]}; team: {tabs: ContentConfigTabItem[]}};
  public readonly Array = Array;

  constructor() {
  }

  ngOnInit(): void {
    this.setContentConfig();
    this.languageSubscription();
  }

  languageSubscription(): void {
    this.langSubscription = this._languageService.onLangChange$.subscribe((event: any) => {
      this.setContentConfig();
    });
  }

  setContentConfig(): void {
    this._translateService.get([
      'FEATURES.END_CONSUMER.TAB_1_TITLE',
      'FEATURES.END_CONSUMER.TAB_1_INFO',
      'FEATURES.END_CONSUMER.TAB_2_TITLE',
      'FEATURES.END_CONSUMER.TAB_2_INFO',
      'FEATURES.END_CONSUMER.TAB_3_TITLE',
      'FEATURES.END_CONSUMER.TAB_3_INFO',

      'FEATURES.PLAYER.TAB_1_TITLE',
      'FEATURES.PLAYER.TAB_1_INFO',
      'FEATURES.PLAYER.TAB_2_TITLE',
      'FEATURES.PLAYER.TAB_2_INFO',
      'FEATURES.PLAYER.TAB_3_TITLE',
      'FEATURES.PLAYER.TAB_3_1_INFO',
      'FEATURES.PLAYER.TAB_3_2_INFO',
      'FEATURES.PLAYER.TAB_3_3_INFO',
      'FEATURES.PLAYER.TAB_3_4_INFO',
      'FEATURES.PLAYER.TAB_3_5_INFO',
      'FEATURES.PLAYER.TAB_3_6_INFO',
      'FEATURES.PLAYER.TAB_3_7_INFO',
      'FEATURES.PLAYER.TAB_3_8_INFO',
      'FEATURES.PLAYER.TAB_3_9_INFO',
      'FEATURES.PLAYER.TAB_3_10_INFO',

      'FEATURES.TEAM.TAB_1_TITLE',
      'FEATURES.TEAM.TAB_1_INFO',
      'FEATURES.TEAM.TAB_2_TITLE',
      'FEATURES.TEAM.TAB_2_1_INFO',
      'FEATURES.TEAM.TAB_2_2_INFO',
      'FEATURES.TEAM.TAB_3_TITLE',
      'FEATURES.TEAM.TAB_3_1_INFO',
      'FEATURES.TEAM.TAB_3_2_INFO',
      'FEATURES.TEAM.TAB_4_TITLE',
      'FEATURES.TEAM.TAB_4_1_INFO',
      'FEATURES.TEAM.TAB_4_2_INFO',
      'FEATURES.TEAM.TAB_4_3_INFO'
    ]).subscribe(translations => {
      const currentLang: string = this._translateService.currentLang;

      this.contentConfig = {
        endConsumer: {
          tabs: [
            {
              active: true,
              tab: translations['FEATURES.END_CONSUMER.TAB_1_TITLE'],
              title: translations['FEATURES.END_CONSUMER.TAB_1_TITLE'],
              gif: `../../../assets/images/features/${currentLang}/end-consumer-pickup-request.gif`, // notify mobile developer if changed it
              info: translations['FEATURES.END_CONSUMER.TAB_1_INFO']
            },
            {
              active: false,
              tab: translations['FEATURES.END_CONSUMER.TAB_2_TITLE'],
              title: translations['FEATURES.END_CONSUMER.TAB_2_TITLE'],
              gif: `../../../assets/images/features/${currentLang}/end-consumer-tracker.gif`, // notify mobile developer if changed it
              info: translations['FEATURES.END_CONSUMER.TAB_2_INFO']
            },
            {
              active: false,
              tab: translations['FEATURES.END_CONSUMER.TAB_3_TITLE'],
              title: translations['FEATURES.END_CONSUMER.TAB_3_TITLE'],
              gif: `../../../assets/images/features/${currentLang}/rewards.gif`, // notify mobile developer if changed it
              info: translations['FEATURES.END_CONSUMER.TAB_3_INFO']
            }
          ]
        },
        player: {
          tabs: [
            {
              active: true,
              tab: translations['FEATURES.PLAYER.TAB_1_TITLE'],
              title: translations['FEATURES.PLAYER.TAB_1_TITLE'],
              gif: `../../../assets/images/features/${currentLang}/player-statistic.gif`, // notify mobile developer if changed it
              info: translations['FEATURES.PLAYER.TAB_1_INFO']
            },
            {
              active: false,
              tab: translations['FEATURES.PLAYER.TAB_2_TITLE'],
              title: translations['FEATURES.PLAYER.TAB_2_TITLE'],
              gif: `../../../assets/images/features/${currentLang}/player-pickup-process.gif`, // notify mobile developer if changed it
              info: translations['FEATURES.PLAYER.TAB_2_INFO']
            },
            {
              active: false,
              tab: translations['FEATURES.PLAYER.TAB_3_TITLE'],
              title: translations['FEATURES.PLAYER.TAB_3_TITLE'],
              gif: `../../../assets/images/features/${currentLang}/player-share-profile.gif`, // notify mobile developer if changed it
              info: [
                translations['FEATURES.PLAYER.TAB_3_1_INFO'],
                translations['FEATURES.PLAYER.TAB_3_2_INFO'],
                translations['FEATURES.PLAYER.TAB_3_3_INFO'],
                translations['FEATURES.PLAYER.TAB_3_4_INFO'],
                translations['FEATURES.PLAYER.TAB_3_5_INFO'],
                translations['FEATURES.PLAYER.TAB_3_6_INFO'],
                translations['FEATURES.PLAYER.TAB_3_7_INFO'],
                translations['FEATURES.PLAYER.TAB_3_8_INFO'],
                translations['FEATURES.PLAYER.TAB_3_9_INFO'],
                translations['FEATURES.PLAYER.TAB_3_10_INFO']
              ].filter(Boolean)
            }
          ]
        },
        team: {
          tabs: [
            {
              active: true,
              tab: translations['FEATURES.TEAM.TAB_1_TITLE'],
              title: translations['FEATURES.TEAM.TAB_1_TITLE'],
              gif: `../../../assets/images/features/${currentLang}/team-management.gif`, // notify mobile developer if changed it
              info:  translations['FEATURES.TEAM.TAB_1_INFO']
            },
            {
              active: false,
              tab: translations['FEATURES.TEAM.TAB_2_TITLE'],
              title: translations['FEATURES.TEAM.TAB_2_TITLE'],
              gif: `../../../assets/images/features/${currentLang}/team-reports.gif`, // notify mobile developer if changed it
              info: [
                translations['FEATURES.TEAM.TAB_2_1_INFO'],
                translations['FEATURES.TEAM.TAB_2_2_INFO']
              ].filter(Boolean)
            },
            {
              active: false,
              tab: translations['FEATURES.TEAM.TAB_3_TITLE'],
              title: translations['FEATURES.TEAM.TAB_3_TITLE'],
              gif: `../../../assets/images/features/${currentLang}/team-pickup-requests.gif`, // notify mobile developer if changed it
              info: [
                translations['FEATURES.TEAM.TAB_3_1_INFO'],
                translations['FEATURES.TEAM.TAB_3_2_INFO']
              ].filter(Boolean)
            },
            {
              active: false,
              tab: translations['FEATURES.TEAM.TAB_4_TITLE'],
              title: translations['FEATURES.TEAM.TAB_4_TITLE'],
              gif: `../../../assets/images/features/${currentLang}/team-share-profile.gif`, // notify mobile developer if changed it
              info: [
                translations['FEATURES.TEAM.TAB_4_1_INFO'],
                translations['FEATURES.TEAM.TAB_4_2_INFO'],
                translations['FEATURES.TEAM.TAB_4_3_INFO']
              ].filter(Boolean)
            }
          ]
        }
      }

      this.initData();
    });
  }

  initData(): void {
    if (this.endConsumerMode) this.tabs = this.contentConfig.endConsumer.tabs;
    if (this.playerMode) this.tabs = this.contentConfig.player.tabs;
    if (this.teamMode) this.tabs = this.contentConfig.team.tabs;

    this.selectTab(this.tabs[0]);
  }

  selectTab(tab: ContentConfigTabItem): void {
    this.tabs.forEach(t => t.active = false);
    tab.active = true;
    this.activeTab = tab;
  }

  ngOnDestroy(): void {
    if (this.langSubscription) this.langSubscription.unsubscribe();
  }
}


export interface ContentConfigTabItem {
  active: boolean;
  tab: string;
  title: string;
  info: string | string[];
  gif: string;
}
